export const lightTheme = {
    name: "light",
    logo: "#55AF97",
    primary: "#67D2B4",
    importentText: "#4EB785",
    bg: "#FFFFFF",
    imageFilter: "rgba(131, 229, 171, 1)",
    buttonBg: "#F7F7F7",
    primaryText: "#262626",
    border: "#262626",
    toggleBg: "#ffffff",
    oppositeTheam: "#303091",
};

export const darkTheme = {
    name: "dark",
    logo: "#9494D6",
    primary: "#4C4C78",
    importentText: "#AFAFFF",
    bg: "#282828",
    imageFilter: "rgba(148, 148, 214, 1)",
    buttonBg: "#262626",
    primaryText: "#D9D9D9",
    border: "#D9D9D9",
    toggleBg: "#d1d1d1",
    oppositeTheam: "#4EB785",
};
